import Dream from '../dream';

/**
 * Create the action
 */

const { thunk, request, success, error } = Dream.update((data, fetch) => {
  // Prepare request
  const formData = new FormData();
  formData.append('_method', 'PUT');

  Object.keys(data).forEach(function (key) {
    if (key === 'file') {
      if (data?.[key]?.constructor === File) {
        formData.append(key, data?.[key]);
      }
    } else if (key === 'activities' || key === 'skills') {
      formData.append(key, JSON.stringify(data[key]));
    } else if (key === 'image') {
      // ignore
    } else {
      formData.append(key, data?.[key]);
    }
  });

  return fetch.post(`/dreams/dream/${data.id}`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
